if (!customElements.get('packing-videos')) {
  customElements.define(
    'packing-videos',
    class PackingVideos extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.packing-videos__track');
        this.navigation = this.querySelector('[data-carousel-navigation]');
        this.previousButton = this.querySelector('[data-carousel-previous]');
        this.nextButton = this.querySelector('[data-carousel-next]');
        this.progress = this.querySelector('.packing-videos__progress');
        this.progressFill = this.querySelector('[data-carousel-progress]');
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.handleScroll = () => {
          window.cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = window.requestAnimationFrame(() => this.updateNavigation());
        };
        this.handlePrevious = () => this.moveByCard(-1);
        this.handleNext = () => this.moveByCard(1);

        this.addEventListener('click', this.handleClick);
        this.track?.addEventListener('scroll', this.handleScroll, { passive: true });
        this.previousButton?.addEventListener('click', this.handlePrevious);
        this.nextButton?.addEventListener('click', this.handleNext);

        this.resizeObserver = new ResizeObserver(() => this.updateNavigation());
        if (this.track) this.resizeObserver.observe(this.track);

        this.mutationObserver = new MutationObserver(() => this.updateNavigation());
        if (this.track) this.mutationObserver.observe(this.track, { childList: true });

        window.requestAnimationFrame(() => this.updateNavigation());
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleClick);
        this.track?.removeEventListener('scroll', this.handleScroll);
        this.previousButton?.removeEventListener('click', this.handlePrevious);
        this.nextButton?.removeEventListener('click', this.handleNext);
        this.resizeObserver?.disconnect();
        this.mutationObserver?.disconnect();
        window.cancelAnimationFrame(this.scrollFrame);
      }

      get cards() {
        return Array.from(this.track?.querySelectorAll('.packing-videos__card') || []);
      }

      moveByCard(direction) {
        if (!this.track) return;

        const cards = this.cards;
        if (cards.length < 2) return;

        const currentIndex = cards.reduce((closestIndex, card, index) => {
          const currentDistance = Math.abs(cards[closestIndex].offsetLeft - this.track.scrollLeft);
          const nextDistance = Math.abs(card.offsetLeft - this.track.scrollLeft);
          return nextDistance < currentDistance ? index : closestIndex;
        }, 0);
        const targetIndex = Math.min(cards.length - 1, Math.max(0, currentIndex + direction));

        this.track.scrollTo({
          left: cards[targetIndex].offsetLeft,
          behavior: this.reducedMotion.matches ? 'auto' : 'smooth',
        });
      }

      updateNavigation() {
        if (!this.track || !this.navigation || !this.progress || !this.progressFill) return;

        const maximumScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const hasOverflow = maximumScroll > 1 && this.cards.length > 1;
        this.navigation.hidden = !hasOverflow;
        if (!hasOverflow) return;

        const position = Math.min(1, Math.max(0, this.track.scrollLeft / maximumScroll));
        const percentage = Math.round(position * 100);
        this.progressFill.style.width = `${4 + position * 96}%`;
        this.progress.setAttribute('aria-valuenow', String(percentage));
        this.previousButton.disabled = position <= 0.01;
        this.nextButton.disabled = position >= 0.99;
      }

      handleClick(event) {
        const button = event.target.closest('.packing-videos__play');
        if (!button) return;

        const media = button.closest('.packing-videos__media');
        const videoId = media?.dataset.videoId || '';
        if (!/^[A-Za-z0-9_-]{6,20}$/.test(videoId)) return;

        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?rel=0`;
        iframe.title = media.dataset.videoTitle || 'Packing video';
        iframe.allow = 'accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.allowFullscreen = true;
        iframe.loading = 'lazy';
        media.replaceChildren(iframe);
        iframe.focus();
      }
    }
  );
}
